module.exports = __webpack_public_path__ + "img/500x500px-CAPA.da6dfe0f.jpg";